import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Login, SharedDataService, Staff } from 'orv-ui-base-lib';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-resetpwd',
  templateUrl: './resetpwd.component.html',
  styleUrls: ['./resetpwd.component.scss']
})
export class ResetpwdComponent implements OnInit {

  message: string;

  userid: number;
  password: string;
  confirmPassword: string;

  constructor(private authService: AuthService,
    private sharedDataService: SharedDataService,
    private router: Router) {
    const token = this.authService.getToken();
    if (!token) {
      this.router.navigateByUrl('/login');
    }
  }

  ngOnInit() {
    this.userid = +this.authService.getUserId();
    // clean all
    this.authService.logout();
  }

  submit() {
    const login = new Login();
    login.md5password = this.password;
    this.authService.resetPwd(this.userid, login).subscribe((data: Staff) => {
      this.sharedDataService.setLoggedUser(data);
      this.router.navigateByUrl('/'); 
    }, ({error}) => {
      this.message = error;
    });
  }

}
